<template>
  <div class="pie-options-setting-dialog">
    <el-collapse v-model="sizeActiveNames" v-if="request_prefix === 'bigScreen'">
      <el-collapse-item title="位置尺寸" name="1">
        <div class="content clearFloat">
          <widthAndSizeAndZindex :options="options" :ids="ids" />
        </div>
      </el-collapse-item>
    </el-collapse>
    <chart-common-options-setting-1 :options="options" :ids="ids"></chart-common-options-setting-1>
    <!--数据/图例设置-->
    <el-collapse v-model="collapseActiveNames">
      <el-collapse-item name="8">
        <template slot="title">
          <div class="tabs flex">
            <div :class="tabsActive == 0 ? 'tabs-item active' : 'tabs-item'" @click="changeActiveHandle($event, 0)">
              数据组
            </div>
            <div :class="tabsActive == 1 ? 'tabs-item active' : 'tabs-item'" @click="changeActiveHandle($event, 1)">
              图例
            </div>
          </div>
        </template>
        <div class="setting-item">
          <template v-if="tabsActive == 0">
            <!--            <collapsibleItem>-->
            <Pie3DSeriesSetting
              :seriesSettingItem="seriesData"
              :options="options"
              :ids="ids"
              ref="seriesSetting"
            ></Pie3DSeriesSetting>
            <!--            </collapsibleItem>-->
          </template>
          <template v-else>
            <legend-setting :options="options" :ids="ids"></legend-setting>
          </template>
        </div>
      </el-collapse-item>
    </el-collapse>
    <chart-common-options-setting :options="options" :ids="ids"></chart-common-options-setting>
  </div>
</template>

<script>
import legendSetting from "toolbarComponents/bigScreen/common/options/legendSetting"
import ChartCommonOptionsSetting from "toolbarComponents/bigScreen/common/chart-common-options-setting"
import ChartCommonOptionsSetting1 from "toolbarComponents/bigScreen/common/chart-common-options-setting-1"
import Pie3DSeriesSetting from "toolbarComponents/bigScreen/common/options/seriesSetting/pie3DSeriesSetting"
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex"

import publicData from "toolbarComponents/bigScreen/common/options/publicData"

export default {
  name: "pie-options-setting",
  components: {
    ChartCommonOptionsSetting,
    ChartCommonOptionsSetting1,
    Pie3DSeriesSetting,
    widthAndSizeAndZindex,
    legendSetting
  },
  mixins: [publicData],
  props: { options: Object },
  data() {
    return {
      this1: this,
      sizeActiveNames: ["1"],
      collapseDataActiveNames: [],
      predefineColors: [
        "#0047FF",
        "#00E4E4",
        "#FFA63F",
        "#D627B0",
        "#C035E3",
        "#802CF5",
        "#8BFF4A",
        "#FFA429",
        "#FF5C5A",
        "#FF58C7",
        "#53FFAC",
        "#FFF91F",
        "#41FFD1",
        "#6D5CFF",
        "#0089FF",
        "#FF6969",
        "#83FF7D",
        "#4EDBFF",
        "#E3FF59",
        "#B700FF"
      ],
      labelTypeList: [
        {
          title: "数据标题",
          value: "{b}"
        },
        {
          title: "百分比",
          value: "{d}%"
        },
        {
          title: "数据标题+百分比",
          value: "{b}:{d}%"
        },
        {
          title: "数值+百分比",
          value: "{c}:{d}%"
        },
        {
          title: "数据标题+数值",
          value: "{b}:{c}"
        }
      ],
      tabsActive: 0, //  显示数据组还是图例
      collapse: {}, // 用来存放当前数据组和图例设置里面的展开收起状态
      labelSelectOptions: [
        {
          label: "样式1",
          value: 1
        },
        {
          label: "样式2",
          value: 2
        }
      ]
    }
  },
  comments: {},
  created() {
    // 图表类组件兼容以前老数据，没有seriesTempAttributes属性的数据
    if (!this.options.chartOption.seriesTempAttributes) {
      const seriesTempAttributes = {
        // 用于存放数据中的通用配置项
        coordinateType: "" //没有坐标系
      }
      this.$changeOptionsEV(seriesTempAttributes, "chartOption.seriesTempAttributes", false)
    }
    // this.getOptionsHandle()
    this.options.chartOption.series.forEach(item => {
      this.collapse[item.name] = {
        isActive: false,
        shape_isActive: false,
        text_isActive: false
      }
    })
  },
  watch: {
    seriesData: {
      handler(newVal, oldVal) {
        if (JSON.parse(JSON.stringify(newVal)) !== JSON.parse(JSON.stringify(oldVal)))
          this.options.chartOption.series.forEach(item => {
            this.collapse[item.name] = {
              isActive: false,
              shape_isActive: false,
              text_isActive: false
            }
          })
      },
      deep: true
    }
  },
  mounted() {},
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    chartOpt() {
      return this.options.chartOption
    },
    // 动态数据
    seriesData: {
      get() {
        if (this.options.chartOption.series) {
          return this.options.chartOption.series
        }
      },
      set(newVal) {
        let params = { ...this.options.chartOption }
        params.series = newVal
        this.$changeOptionsEV(params, "chartOption", false)
      }
    },

    splitWidth: {
      get() {
        return this.hasProperty(this.chartOpt, "series.0.itemStyle.borderWidth")
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "chartOption.series.0.itemStyle.borderWidth", false)
      }
    },
    splitColor: {
      get() {
        return this.hasProperty(this.chartOpt, "series.0.itemStyle.borderColor")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.itemStyle.borderColor", false)
      }
    },
    showLabel: {
      get() {
        return this.hasProperty(this.chartOpt, "series.0.label.show")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.label.show", false)
      }
    },
    labelDataIndex() {
      return this.chartOpt.series.length - 1
    },
    labelFormatter: {
      get() {
        return this.hasProperty(this.chartOpt, "series." + this.labelDataIndex + ".label.formatter")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.labelDataIndex + ".label.formatter", false)
      }
    },
    labelFontFamily: {
      get() {
        return this.hasProperty(this.chartOpt, "series." + this.labelDataIndex + ".label.fontFamily")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.labelDataIndex + ".label.fontFamily", false)
      }
    },
    labelFontColor: {
      get() {
        return this.hasProperty(this.chartOpt, "series." + this.labelDataIndex + ".label.color")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.labelDataIndex + ".label.color", false)
      }
    },
    labelFontWeight: {
      get() {
        return this.hasProperty(this.chartOpt, "series." + this.labelDataIndex + ".label.fontWeight")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.labelDataIndex + ".label.fontWeight", false)
      }
    },
    labelFontSize: {
      get() {
        return this.hasProperty(this.chartOpt, "series." + this.labelDataIndex + ".label.fontSize")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.labelDataIndex + ".label.fontSize", false)
      }
    },
    showLabelLine: {
      get() {
        return this.hasProperty(this.chartOpt, "series." + this.labelDataIndex + ".labelLine.show")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.labelDataIndex + ".labelLine.show", false)
      }
    },
    labelSelectData: {
      get() {
        let pluginName = this.options.chartOption.hasOwnProperty("pluginName")
          ? this.options.chartOption.pluginName
          : []
        return pluginName.indexOf("labelFormaterStringToFuncPlugin") > -1 ? 2 : 1
      },
      set(val) {
        let pluginName = this.options.chartOption.hasOwnProperty("pluginName")
          ? this.options.chartOption.pluginName
          : []
        if (val === 1) {
          //样式1不要插件
          let index = pluginName.indexOf("labelFormaterStringToFuncPlugin")
          pluginName.splice(index, 1)
          this.$changeOptionsEV(null, "chartOption.series.0.labelLayout", false)
        } else if (val === 2) {
          //样式2带插件
          pluginName.push("labelFormaterStringToFuncPlugin")
        }
        this.$changeOptionsEV(pluginName, "chartOption.pluginName", false)
      }
    },
    labelColorType: {
      get() {
        return this.labelLineColor ? "custom" : "default"
      },
      set(val) {
        if (val === "default") {
          this.labelLineColor = null
        } else if (val === "custom") {
          this.labelLineColor = "#fff"
        }
      }
    },
    centerTop: {
      get() {
        return parseInt(this.hasProperty(this.chartOpt, "series.0.center.0"))
      },
      set(newVal) {
        this.$changeOptionsEV(newVal + "%", "chartOption.series.0.center.0", false)
      }
    },
    centerLeft: {
      get() {
        return parseInt(this.hasProperty(this.chartOpt, "series.0.center.1"))
      },
      set(newVal) {
        this.$changeOptionsEV(newVal + "%", "chartOption.series.0.center.1", false)
      }
    }
  },
  methods: {
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        if (val == "8") {
          return
        }
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    // 切换当前tab激活项
    changeActiveHandle(event, flag) {
      event.stopPropagation()
      this.tabsActive = flag
    },
    // 抽屉展开收起方法
    collapsibleItemClickHandle($event, index) {
      this.collapse[$event.type].isActive = $event.isActiveCopy
      const _index = this.collapseDataActiveNames.findIndex(it => it === index)
      _index === -1 ? this.collapseDataActiveNames.push(index + "") : ""
    }
    // getOptionsHandle: function (isChangeStyle) {
    //   this.options = this.$options(this.ids)
    //   // 切换样式的时候，重新渲染颜色等
    //   if (isChangeStyle && this.$refs.seriesSetting) {
    //     this.$refs.seriesSetting[0].init()
    //   }
    // }
  }
}
</script>

<style scoped>
.inlineMiddle {
  display: inline-block;
  vertical-align: middle;
}

.percent100 {
  width: 100%;
}

.height32 {
  height: 32px;
  line-height: 32px;
}

.percent38 {
  width: 38%;
}

.percent72 {
  width: 72%;
}

.height4 {
  height: 4px;
}

.color-picker-container .color-text {
  line-height: 20px;
  display: inline-block;
  vertical-align: top;
  color: inherit;
  font-size: 12px;
  max-width: 60px;
}

.percent80.color-text {
  max-width: 80%;
}

.percent100_80 {
  width: calc(100% - 80px);
}

.item-title-box {
  width: calc(100% - 40px);
  justify-content: space-between;
}

.setting-item .list-label {
  line-height: 32px;
}

.percent42 {
  width: 42%;
}

.percent58 {
  width: calc(58% - 8px);
}

.percent58_60 {
  width: calc(58% - 60px);
}

.pie-options-setting-dialog /deep/ .el-collapse-item__header {
  min-height: 48px;
  height: auto;
}

.percent65_ {
  width: calc(100% - 65px);
}
</style>
<style>
.number-input-box {
  position: relative;
  display: inline-block;
}

.number-input-box .el-input-number .el-input__inner {
  padding-right: 30px;
  text-align: left;
}
.number-input-box .suffix_text {
  position: absolute;
  top: 0;
  line-height: 32px;
  right: 0;
}
.pie-options-setting-dialog .tabs .tabs-item {
  font-weight: 600;
  font-size: 14px;
  line-height: 48px;
  text-align: center;
  color: var(--subTextColor);
  margin-right: 24px;
}
.pie-options-setting-dialog .tabs.lightColor666 .tabs-item {
  color: rgba(0, 0, 0, 0.6);
}
.pie-options-setting-dialog .tabs .tabs-item.active {
  color: var(--themeColor);
  border-bottom: 2px solid;
}
.lightColor666 {
  color: rgba(0, 0, 0, 0.6);
}
</style>
